import { render, staticRenderFns } from "./TellMeMore.vue?vue&type=template&id=25f5f962&scoped=true&"
import script from "./TellMeMore.vue?vue&type=script&lang=js&"
export * from "./TellMeMore.vue?vue&type=script&lang=js&"
import style0 from "./TellMeMore.vue?vue&type=style&index=0&id=25f5f962&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5f962",
  null
  
)

export default component.exports